import { FC } from 'react';
import { updateImageUrl } from 'utils/convertString';
import { AvatarIcon } from 'components/Core/AvatarIcon';
import { IEntityOptionProps } from './types';
import { AVATAR_SIZE } from './constants';
import styles from './entityOption.module.scss';

const EntityOption: FC<IEntityOptionProps> = ({ image, entityType, name, children }) => {
  return (
    <div className={`${styles.entityOption}`}>
      {image && (
        <AvatarIcon
          avatar={updateImageUrl(image, AVATAR_SIZE[entityType] * 2)}
          name={name}
          size={AVATAR_SIZE[entityType]}
        />
      )}
      <div className={styles.optionLabel}>
        <p className={styles.optionName}>{name}</p>
      </div>
      {children}
      {/* {data.entityType === 'products' && (
        <div className={styles.optionPrice}>
          {data.discountPrice ? <p className={`${styles.discount}`}>{data.discountPrice}</p> : null}
          <p className={`${data.discountPrice && styles.originalPrice}`}>{data.price}</p>
        </div>
      )} */}
    </div>
  );
};
export default EntityOption;
